import { createContext, useContext, useState } from "react";
import {
  createBalance as createBalanceAPI,
  getBalanceById as getBalanceByIdAPI,
  updateBalance as updateBalanceAPI,
  getBalances,
} from "API/swesum";

const BalancesContext = createContext(null);

export const BalancesContextProvider = ({ children }) => {
  const [balances, setBalances] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  const fetchBalances = async (body, clientId = null, force = false) => {
    setLoading(true);
    const newBalances = await getBalances(body, clientId);
    if (force) {
      setBalances(newBalances);
    } else {
      setBalances([...balances, ...newBalances]);
    }
    setIsInitialized(true);
    setLoading(false);
    return newBalances;
  };

  const createBalance = async (body) => {
    setLoading(true);
    const res = await createBalanceAPI(body);
    if (res.status === 201) {
      const tmpBalances = [...balances, res.data];
      setBalances(tmpBalances);
    }
    setLoading(false);
    return res;
  };

  const updateBalance = async (id, body) => {
    setLoading(true);
    const res = await updateBalanceAPI(id, body);

    if (res.status === 201) {
      setBalances((currentBalances) =>
        currentBalances.map((balance) =>
          Number(balance.Id) === Number(id) ? { ...balance, ...body } : balance
        )
      );
    }
    setLoading(true);
    return res;
  };

  const getBalanceById = async (id) => {
    let balance = balances.find((account) => Number(account.Id) === Number(id));
    if (!balance) {
      balance = await getBalanceByIdAPI(id);
      setBalances([...balances, balance]);
    }
    return balance;
  };

  return (
    <BalancesContext.Provider
      value={{
        balances,
        getBalanceById,
        fetchBalances,
        createBalance,
        isInitialized,
        updateBalance,
        loading,
      }}
    >
      {children}
    </BalancesContext.Provider>
  );
};

export const useBalances = () => useContext(BalancesContext);
